module.exports = __webpack_public_path__ + "3a80e2d86025d3d5b3fe1922af00a5cd.fbx";